module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('header', {
    staticClass: "gheader -white"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goVideoCategories()
      }
    }
  }, [_vm._v("戻る")])])]), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "yeswecan",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0001.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0002.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0003.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0004.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0005.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0006.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0007.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0008.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0009.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0010.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0011.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0012.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0013.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0014.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0015.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0016.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0017.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0018.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0019.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0020.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0021.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0022.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0023.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0024.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0025.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0026.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0027.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0028.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0029.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0030.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0031.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0032.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0033.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0034.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0035.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0036.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0037.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0038.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0039.png"),
      "width": "100%"
    }
  })])]), _c('swiper-slide', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/yeswecan0040.png"),
      "width": "100%"
    }
  })])]), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10fd89d0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/yes-we-can.pug
// module id = 1388
// module chunks = 1